import { Component, Input, OnInit } from "@angular/core";
import { DomSanitizer } from "@angular/platform-browser";
import { Router } from "@angular/router";
import { EssentialService } from "../../services/essential.service";
declare const $: any;

@Component({
  selector: "app-search",
  templateUrl: "./search.component.html",
  styleUrls: ["./search.component.css"],
})
export class SearchComponent implements OnInit {
  @Input() public settings: any;
  @Input() public data: any;
  public showSearchOptions: boolean = false;
  public isShowOptions: boolean = false;
  public showResult: boolean = false;
  public searchText: string = "";
  public selectedOption: string = "1";
  pageSize: any = "10";
  currentPage: number = 1;
  totalCount: number;

  listItems: any[] = [];
  public apiUrl = window["config"].apiUrl + "/";
  site: any;

  constructor(
    private router: Router,
    private essentialService: EssentialService,
    private sinitizer: DomSanitizer
  ) { }

  ngOnInit() {

    this.site = this.data.moduleService.site;

    this.settings.searchOptions.subOptions.forEach(element => {
      if (element.selected)
        this.selectedOption = element.id;
    });

    this.checkIfOptions();
    this.searchInList();
    this.showHideSuggestions();
  }

  public checkIfOptions() {
    if (
      this.settings.searchOptions &&
      this.settings.searchOptions.subOptions &&
      this.settings.searchOptions.subOptions.filter((t) => t.selected).length >
      0
    )

      this.isShowOptions = true;
    for (var i = 0; i < this.settings.searchIn.length; i++) {
      var element = this.settings.searchIn[i];
      if (element.selected) {
        this.selectedOption = element.id;
        break;
      }
    }

  }
  public searchInList() {
    if (
      this.settings.searchOptions &&
      this.settings.searchOptions.subOptions &&
      this.settings.searchOptions.subOptions.filter((t) => t.selected).length >
      0 &&
      this.settings.searchOptions.subOptions[1].options.filter(
        (t) => t.selected
      ).length > 0
    ) {
      this.settings.searchOptions.subOptions.forEach((element1) => {
        if (element1.id != 1) {
          element1.options.forEach((element) => {
            element.isSearchable = true;
          });
        }
      });
    }
  }

  public openSearchOption() {
    this.showSearchOptions = !this.showSearchOptions;
  }

  public search(source?) {
    if (!this.searchText) {
      return;
    }


    this.showResult = false;
    if (source == 1 && !this.settings.redirectOnSearch.isEnabled) {
      this.searchResult();
    } else if (source == 2) {

      if (
        this.settings.searchOptions &&
        this.settings.searchOptions.subOptions &&
        this.settings.searchOptions.subOptions[1].options
      ) {
        var ids = [];
        this.settings.searchOptions.subOptions[1].options.forEach((element) => {
          if (element.isSearchable && element.selected) {
            ids.push(element.id);
          }
        });
      }

      const targetRoute = this.settings.redirectOnSearch.isEnabled ? this.settings.redirectOnSearch.targetPage : "/search-result";

      const defaultParams = {
        search: this.searchText,
        searchOptionId: this.selectedOption,
        subSearchOptions: ids,
      }

      const redirectOnSearchParams = {
        [this.settings.redirectOnSearch.query]: this.searchText
      }

      this.router.navigate([targetRoute], {
        queryParams: this.settings.redirectOnSearch.isEnabled ? redirectOnSearchParams : defaultParams
      });

      if (this.settings.redirectOnSearch.isEnabled) {
        console.log({ text: this.searchText, redirectOptions: this.settings.redirectOnSearch })
      } else {



      }

    }
  }

  public searchResult() {
    var ids = [];
    if (this.settings.searchOptions && this.settings.searchOptions.subOptions) {
      this.settings.searchOptions.subOptions[1].options.forEach((element) => {
        if (element.isSearchable && element.selected) {
          ids.push(element.id);
        }
      });
    }
    var query: any = {
      searchValue: this.searchText,
      pageSize: this.pageSize,
      pageNumber: this.currentPage,
      searchOptionId: this.selectedOption,
      subSearchOptions: ids,
    };

    this.essentialService.search(query).subscribe((data: any) => {
      this.totalCount = data.totalLength;
      this.showResult = true;
      if (Object.keys(data).length) {
        this.listItems = data.listItems;
      }
    });
  }

  public getImage(img?) {
    return this.sinitizer.bypassSecurityTrustUrl(img);
  }

  public showHideSuggestions() {
    $(document).click(function (e) {
      var container = $("app-search");
      // If the target of the click isn't the container
      if (!container.is(e.target) && container.has(e.target).length === 0) {
        $("#suggestion-results").hide();
      }
      $(".search-comp").focusin(function () {
        if (
          $("#suggestion-results").length > 0 &&
          $("#search-input-control").val() &&
          $("#search-options").length == 0
        ) {
          $("#suggestion-results").show();
        }
      });
    });
  }
}
